import React from 'react';
import { Button } from './ui/button';

const RijekaButton = ({ children, variant = 'primary', ...props }) => {
  // Use inline styles with CSS variables for dynamic theming
  const getButtonStyle = () => {
    const baseStyle = {
      fontFamily: 'var(--font-body)'
    };
    
    switch (variant) {
      case 'primary':
        return {
          ...baseStyle,
          backgroundColor: 'var(--color-primary)',
          color: 'var(--color-text-white)',
          border: 'none'
        };
      case 'outline':
        return {
          ...baseStyle,
          backgroundColor: 'transparent',
          border: '2px solid var(--color-primary)',
          color: 'var(--color-primary)'
        };
      case 'dark':
        return {
          ...baseStyle,
          backgroundColor: 'var(--color-dark)',
          color: 'var(--color-text-white)',
          border: 'none'
        };
      default:
        return {
          ...baseStyle,
          backgroundColor: 'var(--color-primary)',
          color: 'var(--color-text-white)',
          border: 'none'
        };
    }
  };

  const handleMouseEnter = (e) => {
    if (variant === 'primary') {
      e.target.style.backgroundColor = 'var(--color-primary-hover)';
    } else if (variant === 'outline') {
      e.target.style.backgroundColor = 'var(--color-primary)';
      e.target.style.color = 'var(--color-text-white)';
    } else if (variant === 'dark') {
      e.target.style.backgroundColor = 'var(--color-dark-hover)';
    }
  };

  const handleMouseLeave = (e) => {
    const style = getButtonStyle();
    e.target.style.backgroundColor = style.backgroundColor;
    e.target.style.color = style.color;
  };

  return (
    <Button
      {...props}
      style={getButtonStyle()}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`rounded-none transition-all duration-300 ${props.className || ''}`}
    >
      {children}
    </Button>
  );
};

export default RijekaButton;
